import Link from 'next/link';
import type React from 'react';
import { type FC, useMemo, useState } from 'react';

import { ImageComponent } from '@/components/Image';
import { nickEncrypting } from '@/helpers/common';
import type { NewWinnerI as WinnerProps } from '@/helpers/winner';
import { useGetCommonStore } from '@/store/commonStore';

import { ScNewWinnerWrapp } from './styled';

export const NewWinner: FC<WinnerProps> = ({
  nickname,
  gameTitle,
  humanizedWin,
  gameTableImagePath,
  gameFullPath,
  onClick,
}) => {
  const [notFoundImage, setNotFoundImage] = useState(false);
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const handleImageError = () => {
    setNotFoundImage(true);
  };

  const gameUrl = useMemo(() => {
    if (isAuthenticated) return `/game/${gameFullPath}`;

    return `/game/${gameFullPath}?demo=true`;
  }, [isAuthenticated, gameFullPath]);

  const handleCLick = (e: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <ScNewWinnerWrapp>
      <div className="content">
        <Link
          className="img-block"
          href={gameUrl}
          onClick={(e) => handleCLick(e)}
        >
          {!notFoundImage && (
            <ImageComponent
              alt={gameTitle}
              height={56}
              onError={handleImageError}
              src={gameTableImagePath}
              width={56}
            />
          )}
        </Link>
        <div className="winner-info">
          <div className="prize">{humanizedWin}</div>
          <p className="winner">
            {nickEncrypting(nickname)} in {gameTitle}
          </p>
        </div>
      </div>
      <Link className="win-btn" href={gameUrl} onClick={(e) => handleCLick(e)}>
        Win
      </Link>
    </ScNewWinnerWrapp>
  );
};
